import { useInferenceCreateContext } from "domains/inference/contexts/InferenceProvider";
import {
  getApiControlEndValue,
  getFrontendControlEndValue,
  getIsControlEndAvailable,
} from "domains/inference/utils/controlEnd";
import SliderWithInputNumber from "domains/ui/components/SliderWithInputNumber";

export function ControlEndSlider({
  controlEnd,
  setControlEnd,
}: {
  controlEnd: number;
  setControlEnd: (controlEnd: number) => void;
}) {
  return (
    <SliderWithInputNumber
      valueStyleProps={{ w: "50px" }}
      title="Duration"
      tooltip="Defines the share of generation steps guided by the ControlNet reference."
      value={getFrontendControlEndValue(controlEnd)}
      setValue={(newValue) => {
        setControlEnd(
          getApiControlEndValue(newValue !== undefined ? newValue : controlEnd)
        );
      }}
      min={10}
      max={100}
      data-testid="inference-builder-controlend-slider"
      step={1}
    />
  );
}

export default function SidebarSliderControlEnd() {
  const { controlEnd, setControlEnd, model, inferenceType } =
    useInferenceCreateContext();

  if (
    !inferenceType.startsWith("controlnet") ||
    !getIsControlEndAvailable(model)
  ) {
    return null;
  }

  return (
    <ControlEndSlider controlEnd={controlEnd} setControlEnd={setControlEnd} />
  );
}
